import React, {useEffect, useState} from 'react';
import OptionalMenu from '../../../components/optional-menu/optional-menu';
import {optionalMenuDevice} from '../optional-menu-items';
import {Route, Routes, useNavigate} from 'react-router-dom';
import _ from 'lodash';
import {actions, Control, Form} from 'react-redux-form';
import CustomSelect from '../../../components/custom-select/custom-select';
import CustomInput from '../../../components/custom-input/custom-input';
import {connect, useDispatch} from 'react-redux';
import {DEVICE_MODE} from '../../../enums/device-mode';
import {useTranslation} from 'react-i18next';
import {getRelay, putRelay} from "../../../services/relays.service";
import {sensorList} from "../../../lists/sensors-list";
import {SensorChild} from "./sensor-child";
import Loader from 'react-loader-spinner'
import {setDataInStore} from "../../../utils/setDataInStore";
import {getAllNames} from "../../../services/names.service";
import {humidityList} from "../../../lists/humidity-list";
import InputIcon from "@material-ui/icons/Input";
import LensIcon from "@material-ui/icons/Lens";
import {Button} from "@material-ui/core";
import {AppState} from "../../../store/store";
import {ManualSettings} from "./manual-settings";

export interface DeviceProps {
    mode?: DEVICE_MODE,
    input?: number,
    reactionTime?: string,
    holdingTime?: string,
    timeSettings?: any[],
    temp1?: string,
    temp2?: string,
    h1?: string,
    h2?: string,
    isActive?: boolean,
}



interface DeviceViewChildProps {
    relayId: string;
    deviceNames: object;
}
const PureDeviceViewChild: React.FC<DeviceViewChildProps> = (props) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    useEffect(() => {
        setData({});
        setLoading(true);
        if (props.relayId) {
            getRelay(props.relayId)
                .then((data) => {
                    setData(data);
                    setDataInStore(dispatch, data, props.relayId);
                    setLoading(false)
                })
                .catch((err) => {
                    setLoading(false);
                });
        }
    }, [props.relayId]);

    const getName = () => {
        if(props.relayId.includes('relay')) {
            return _.get(props.deviceNames, 'relays.' + props.relayId, '');
        } else if (props.relayId.includes('irda')) {
            return _.get(props.deviceNames, 'irda.' + props.relayId, '');
        } else if (props.relayId.includes('analog')) {
            return _.get(props.deviceNames, 'analogs.' + props.relayId, '');
        }
        return '';
    }
    if (data !== {} && !loading) {
        if (props.relayId.includes('analog')) {
            return (
                <div className='d-flex justify-content-center w-100 align-items-start router-container'>
                    {
                        props.relayId && <AnalogOutputChild id={props.relayId} deviceName={getName()} device={data} names={props.deviceNames} />
                    }
                </div>
            )
        }
        return (
            <div className='d-flex justify-content-center w-100 align-items-start router-container'>
                {
                    props.relayId && <SensorChild id={props.relayId} inputKey='input_relay' device={data} deviceName={getName()} names={props.deviceNames} />
                }
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
}
const mapStateToPropsDevice = (state: AppState) => ({
    state: state
});
const DeviceViewChild = connect(mapStateToPropsDevice)(PureDeviceViewChild);

interface IAnalogOutputChild {
    id: string;
    device: any;
    names: object;
    deviceName: string;
    state: AppState
}
const PureAnalogOutputChild: React.FC<IAnalogOutputChild> = (props) => {
    const {t} = useTranslation();
    const [currentDeviceStatus, setCurrentDeviceStatus] = useState<boolean | undefined>(false);
    const [disableButtons, setDissableButtons] = useState(false);
    const sensorsList = sensorList.map((item) => {
        return {
            value: item.value,
            label: _.get(props.names, 'temperature.' + item.key, item.key),
            key: item.key
        }
    }).concat(humidityList.map((h) => {
        return {
            value: h.value + 6,
            label: _.get(props.names, 'humidity.' + h.key, h.key),
            key: h.key
        }
    }))
    useEffect(() => {
        setCurrentDeviceStatus(props.device.isActive);
    }, [props.device]);
    const handleSave = () => {
        setDissableButtons(true);
        const analog = _.get(props.state, 'analog1', {});
        setCurrentDeviceStatus(false)
        const analogToSave = _.assign({}, analog, {
            isActive: false
        });
        putRelay(props.id, analogToSave, 0, false).finally(() => setTimeout(() => setDissableButtons(false), 1000))
    }
    const handleSubmit = (device: any) => {
        setDissableButtons(true);
        putRelay(props.id, device, 0, !currentDeviceStatus).finally(() => setTimeout(() => setDissableButtons(false), 1000))
        setCurrentDeviceStatus(!currentDeviceStatus);
    }
    return (
        <div className='card default-card'>
            <div className="card-body">
                <Form model={props.id}
                      onSubmit={(device) => handleSubmit(device)}>
                        <div className='d-flex justify-content-center'>
                                <span className=''>{currentDeviceStatus ? t('active') :  t('notactive')}</span>
                                <LensIcon className={currentDeviceStatus ? 'greenLens' : 'redLens'}/>
                            </div>
                    <div className='card-title-container'>
                        <div className='card-title-with-icon'>
                            <InputIcon/>
                        </div>
                        <span className='card-title'>{props.deviceName}</span>
                    </div>
                    <div className='default-row'>
                        <div className='default-field'>
                            <Control.select
                                model={props.id + ".input"}
                                component={CustomSelect}
                                label={t('input')}
                                mapProps={{
                                    options: () => sensorsList,
                                    id: () => ''
                                }}
                                id={''} />
                        </div>
                        <div className='default-field'>
                            <Control
                                model={props.id + ".voltageDown"}
                                component={CustomInput}
                                label={t('minValue')}
                                id={props.id + '.voltageDown'} />
                        </div>
                        <div className='default-field'>
                            <Control
                                model={props.id + ".voltageUp"}
                                component={CustomInput}
                                label={t('maxValue')}
                                id={props.id + '.voltageUp'} />
                        </div>
                    </div>
                    <div className='modal-action-row'>
                        <Button variant="outlined" disabled={disableButtons} onClick={handleSave} type='button' color="primary" className='modal-default-button'>
                            {t('save')}
                        </Button>
                        <Button variant="contained" disabled={disableButtons} type='submit' color="primary" className='modal-default-button'>
                            {!currentDeviceStatus ? t('activate') : t('deactivate')}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}
const mapStateToProps = (state: AppState) => ({
    state: state
});
const AnalogOutputChild = connect(mapStateToProps)(PureAnalogOutputChild);

const DeviceView: React.FC = () => {

    const navigate = useNavigate();
    const [key, setKey] = useState('');
    const [loading, setLoading] = useState(true);
    const [names, setNames] = useState({});
    useEffect(() => {
        getAllNames().then(
            (res) => {
                        setNames(res);
                        optionalMenuDevice.value.sensors.items.map((item) => {
                            _.assign(item, {
                                label: _.get(res, 'relays.' + item.key, item.key)
                            })
                            return item;
                        });
                        optionalMenuDevice.value.irda.items.map((item) => {
                            _.assign(item, {
                                label: _.get(res, 'irda.' + item.key, item.key)
                            })
                            return item;
                        });
                        optionalMenuDevice.value.analogOutput.items.map((item) => {
                            _.assign(item, {
                                label: _.get(res, 'analogs.' + item.key, item.key)
                            })
                            return item;
                        })
                        setLoading(false);
            }
        )
            .catch((err) => setLoading(false))
    }, [])
    const handleChangeDeviceKey = (k: string) => {
        setKey(k);
        const pathname = window.location.pathname;
        if (pathname.includes('device')) {
            navigate(k);
        } else {
            navigate( 'device/' + k);
        }
    }
    if (!loading) {
        return (
            <div className='d-flex w-100'>
                <OptionalMenu {...optionalMenuDevice} onChange={handleChangeDeviceKey} />
                <Routes>
                    <Route path=":id" element={<DeviceViewChild relayId={key} deviceNames={names} />} />
                    <Route path="manualSettingsList" element={<ManualSettings deviceNames={names}/>} />
                </Routes>
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
}

export default connect(null)(DeviceView);
